export const SET_API_BASEURL = 'SET_API_BASEURL'
export const SET_API_KEY_INSEE = 'SET_API_KEY_INSEE'
export const SET_DATA_CLIENT = 'SET_DATA_CLIENT'
export const SET_ORDERS_CLIENT = 'SET_ORDERS_CLIENT'
export const SET_DATA_LOCATIONS = 'SET_DATA_LOCATIONS'
export const SET_DATA_NEWSLETTERS = 'SET_DATA_NEWSLETTERS'
export const SET_COURSE = 'SET_COURSE'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REGISTER_TRAINEE = 'REGISTER_TRAINEE'
export const REMOVE_FROM_REGISTRED_LIST = 'REMOVE_FROM_REGISTRED_LIST'
export const RESTORE_MUTATION = 'RESTORE_MUTATION'
export const SET_COUNT = 'SET_COUNT'
export const UPDATE_QTY = 'UPDATE_QTY'
export const QTY_UPP = 'QTY_UPP'
export const QTY_DOWN = 'QTY_DOWN'
export const SET_STEP = 'SET_STEP'
export const SET_CART_UPDATED_AT_DATE = 'SET_CART_UPDATED_AT_DATE'
export const IATA_TOGGLE = 'IATA_TOGGLE'
export const DELETE_TRAINEE = 'DELETE_TRAINEE'
export const ADD_TRAINEE = 'ADD_TRAINEE'
export const CLEAR_CART = 'CLEAR_CART'
export const SET_COMPANY = 'SET_COMPANY'
export const CLEAR_COMPANY = 'CLEAR_COMPANY'
export const SET_ESTABLISHMENT = 'SET_ESTABLISHMENT'
export const CLEAR_ESTABLISHMENT = 'CLEAR_ESTABLISHMENT'
export const SET_TRAINEES = 'SET_TRAINEES'
export const SET_FILTRED_LIST = 'SET_FILTRED_LIST'
export const SET_COURSES = 'SET_COURSES'
export const SET_REGISTRATIONS = 'SET_REGISTRATIONS'
export const SET_RESULTS = 'SET_RESULTS'
export const SET_HABILITATIONS = 'SET_HABILITATIONS'
export const SET_MONITORING_HABILITATIONS = 'SET_MONITORING_HABILITATIONS'
export const SET_HABILITATIONS_CODES = 'SET_HABILITATIONS_CODES'
export const SET_FILTRED_REGISTRATIONS = 'SET_FILTRED_REGISTRATIONS'
export const SET_FILTRED_RESULTS = 'SET_FILTRED_RESULTS'
export const SET_COMPLIANCE_LIST = 'SET_COMPLIANCE_LIST'
export const SET_DATA_TO_CLIENT = 'SET_DATA_TO_CLIENT'
